/**
 *
 *
 * ENUMS
 *
 *
 */

export let ElementType = /*#__PURE__*/function (ElementType) {
  ElementType["Text"] = "Text";
  ElementType["Button"] = "Button";
  ElementType["Buttons"] = "Buttons";
  ElementType["Image"] = "Image";
  ElementType["AppStoreButton"] = "AppStoreButton";
  ElementType["SocialLinks"] = "SocialLinks";
  ElementType["Form"] = "Form";
  ElementType["Video"] = "Video";
  ElementType["Counter"] = "Counter";
  return ElementType;
}({});
export let ButtonDesignStyle = /*#__PURE__*/function (ButtonDesignStyle) {
  ButtonDesignStyle["Primary"] = "Primary";
  ButtonDesignStyle["Secondary"] = "Secondary";
  ButtonDesignStyle["Tertiary"] = "Tertiary";
  return ButtonDesignStyle;
}({});
export let ButtonDesignSize = /*#__PURE__*/function (ButtonDesignSize) {
  ButtonDesignSize["Fit"] = "Fit";
  ButtonDesignSize["Fill"] = "Fill";
  return ButtonDesignSize;
}({});
export let ButtonActionType = /*#__PURE__*/function (ButtonActionType) {
  ButtonActionType["InternalLink"] = "InternalLink";
  ButtonActionType["ExternalLink"] = "ExternalLink";
  ButtonActionType["Email"] = "Email";
  ButtonActionType["Phone"] = "Phone";
  ButtonActionType["Button"] = "Button";
  ButtonActionType["Submit"] = "Submit";
  return ButtonActionType;
}({});
export let ImageActionType = /*#__PURE__*/function (ImageActionType) {
  ImageActionType["InternalLink"] = "InternalLink";
  ImageActionType["ExternalLink"] = "ExternalLink";
  ImageActionType["ScaleUp"] = "ScaleUp";
  ImageActionType["DoNothing"] = "DoNothing";
  return ImageActionType;
}({});
export let ImageObjectFit = /*#__PURE__*/function (ImageObjectFit) {
  ImageObjectFit["None"] = "None";
  ImageObjectFit["Fill"] = "Fill";
  ImageObjectFit["Cover"] = "Cover";
  ImageObjectFit["Contain"] = "Contain";
  return ImageObjectFit;
}({});
export let AppStoreButtonDesignSize = /*#__PURE__*/function (AppStoreButtonDesignSize) {
  AppStoreButtonDesignSize["Small"] = "Small";
  AppStoreButtonDesignSize["Medium"] = "Medium";
  AppStoreButtonDesignSize["Large"] = "Large";
  return AppStoreButtonDesignSize;
}({});
export let AppStoreButtonActionType = /*#__PURE__*/function (AppStoreButtonActionType) {
  AppStoreButtonActionType["Apple"] = "Apple";
  AppStoreButtonActionType["Google"] = "Google";
  AppStoreButtonActionType["Samsung"] = "Samsung";
  AppStoreButtonActionType["Huawei"] = "Huawei";
  return AppStoreButtonActionType;
}({});
export let AppStoreButtonDesignStyle = /*#__PURE__*/function (AppStoreButtonDesignStyle) {
  AppStoreButtonDesignStyle["Brand"] = "Brand";
  AppStoreButtonDesignStyle["Black"] = "Black";
  AppStoreButtonDesignStyle["White"] = "White";
  return AppStoreButtonDesignStyle;
}({});
export let SocialLinkName = /*#__PURE__*/function (SocialLinkName) {
  SocialLinkName["Behance"] = "behance";
  SocialLinkName["Discord"] = "discord";
  SocialLinkName["Dribbble"] = "dribbble";
  SocialLinkName["Facebook"] = "facebook";
  SocialLinkName["Messenger"] = "messenger";
  SocialLinkName["Github"] = "github";
  SocialLinkName["Instagram"] = "instagram";
  SocialLinkName["Linkedin"] = "linkedin";
  SocialLinkName["Pinterest"] = "pinterest";
  SocialLinkName["Skype"] = "skype";
  SocialLinkName["Telegram"] = "telegram";
  SocialLinkName["Tiktok"] = "tiktok";
  SocialLinkName["Twitter"] = "twitter";
  SocialLinkName["Whatsapp"] = "whatsapp";
  SocialLinkName["Youtube"] = "youtube";
  SocialLinkName["Snapchat"] = "snapchat";
  return SocialLinkName;
}({});
export let FieldType = /*#__PURE__*/function (FieldType) {
  FieldType["Text"] = "Text";
  FieldType["Email"] = "Email";
  FieldType["Phone"] = "Phone";
  FieldType["TextArea"] = "TextArea";
  FieldType["Link"] = "Link";
  FieldType["Date"] = "Date";
  FieldType["Checkbox"] = "Checkbox";
  FieldType["Radio"] = "Radio";
  FieldType["Select"] = "Select";
  FieldType["Time"] = "Time";
  FieldType["File"] = "File";
  return FieldType;
}({});
export let FormPostSubmitType = /*#__PURE__*/function (FormPostSubmitType) {
  FormPostSubmitType["Message"] = "Message";
  FormPostSubmitType["Redirect"] = "Redirect";
  return FormPostSubmitType;
}({});
export let AutoCompleteType = /*#__PURE__*/function (AutoCompleteType) {
  AutoCompleteType["Name"] = "name";
  AutoCompleteType["UserName"] = "username";
  AutoCompleteType["OrganizationTitle"] = "organization-title";
  AutoCompleteType["Organization"] = "organization";
  AutoCompleteType["StreetAddress"] = "street-address";
  AutoCompleteType["AddressLine1"] = "address-line1";
  AutoCompleteType["AddressLine2"] = "address-line2";
  AutoCompleteType["AddressLine3"] = "address-line3";
  AutoCompleteType["Country"] = "country";
  AutoCompleteType["CountryName"] = "country-name";
  AutoCompleteType["PostalCode"] = "postal-code";
  AutoCompleteType["Language"] = "language";
  AutoCompleteType["Sex"] = "sex";
  AutoCompleteType["Email"] = "email";
  AutoCompleteType["Phone"] = "phone";
  AutoCompleteType["Url"] = "url";
  return AutoCompleteType;
}({});
export let SelectionsLimitationType = /*#__PURE__*/function (SelectionsLimitationType) {
  SelectionsLimitationType["Limited"] = "Limited";
  SelectionsLimitationType["Unlimited"] = "Unlimited";
  return SelectionsLimitationType;
}({});
export let ShadowType = /*#__PURE__*/function (ShadowType) {
  ShadowType["none"] = "none";
  ShadowType["outer"] = "outer";
  ShadowType["inner"] = "inner";
  return ShadowType;
}({});
export let IconShape = /*#__PURE__*/function (IconShape) {
  IconShape["Filled"] = "Filled";
  IconShape["Outlined"] = "Outlined";
  IconShape["Colored"] = "Colored";
  return IconShape;
}({});
export let UtilityPageType = /*#__PURE__*/function (UtilityPageType) {
  UtilityPageType["NOT_FOUND_PAGE"] = "NOT_FOUND_PAGE";
  UtilityPageType["UNDER_MAINTENANCE_PAGE"] = "UNDER_MAINTENANCE_PAGE";
  return UtilityPageType;
}({});
export let ColorsType = /*#__PURE__*/function (ColorsType) {
  ColorsType["brand1"] = "--theme-color-brand1";
  ColorsType["brand2"] = "--theme-color-brand2";
  ColorsType["brand3"] = "--theme-color-brand3";
  ColorsType["brand4"] = "--theme-color-brand4";
  ColorsType["secondary1"] = "--theme-color-secondary1";
  ColorsType["secondary2"] = "--theme-color-secondary2";
  ColorsType["secondary3"] = "--theme-color-secondary3";
  ColorsType["secondary4"] = "--theme-color-secondary4";
  ColorsType["base1"] = "--theme-color-base1";
  ColorsType["base2"] = "--theme-color-base2";
  ColorsType["base3"] = "--theme-color-base3";
  ColorsType["base4"] = "--theme-color-base4";
  ColorsType["base5"] = "--theme-color-base5";
  ColorsType["accent1"] = "--theme-color-accent1";
  ColorsType["accent2"] = "--theme-color-accent2";
  return ColorsType;
}({});
//# sourceMappingURL=elementSettingsEnums.js.map